import React from 'react';
import { UpdateRodRoomErrorCode } from '@bechtel/types';
import { ApolloError } from '@apollo/client';
import { Trans } from '@lingui/macro';

export const getError = (error) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateRodRoomErrorCode.INVALID_ELEVATION_VALUE:
      return <Trans>Invalid Elevation Value.</Trans>;
    case UpdateRodRoomErrorCode.INVALID_LATITUDE_VALUE:
      return <Trans>Invalid Latitude Value.</Trans>;
    case UpdateRodRoomErrorCode.INVALID_LONGITUDE_VALUE:
      return <Trans>Invalid Longitude Value.</Trans>;
    case UpdateRodRoomErrorCode.INVALID_ROD_ROOM_ID:
      return <Trans>Invalid Rod Room Id.</Trans>;
    case UpdateRodRoomErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing Required Permission.</Trans>;
    case UpdateRodRoomErrorCode.NOTHING_TO_UPDATE:
      return <Trans>Nothing To Update.</Trans>;
    case UpdateRodRoomErrorCode.UPDATE_ROD_ROOM_ERRORED:
      return <Trans>Error in Backend.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};
